export default __webpack_public_path__ + "static/openess-logo-551a1bff82fed2d8b75f6f91b197e5d8.svg";